module.exports = __webpack_public_path__ + "img/TractionLinux3.5ba13fe4.png";